import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'sortNumber'
})

@Injectable()
export class SortBigestNumber implements PipeTransform {
    transform(array: any[], field: string, descending?: boolean): any[] {
        if (descending === true) {
            array.sort((a: any, b: any) => {
                if (a[field] < b[field]) {
                    return -1;
                } else if (a[field] > b[field]) {
                    return 1;
                } else {
                    return 0;
                }
            });
        } else {
            array.sort((a: any, b: any) => {
                let acellValue = a;
                let anumberOnly = acellValue[field].toString().replace(/\D/g, '');
                let bcellValue = b;
                let bnumberOnly = bcellValue[field].toString().replace(/\D/g, '');
                if (+anumberOnly > +bnumberOnly) {
                    return -1;
                } else if (+anumberOnly < +bnumberOnly) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
        return array;
    }
}